import { createSelector } from "reselect";
import _ from "lodash";
export const getQualificationList = ({ Qualifications_reducer }) => {
    return Qualifications_reducer.qualificationList;
};
export const getUsers = ({ Qualifications_reducer }) => {
    return Qualifications_reducer.users;
};
export const selectRegisteredUsers = createSelector(
    [getUsers],
    users => {
        if (users === false || typeof users === "undefined" || users === null) {
            return [];
        }

        let regUsers = Object.keys(users).map(e => {
            return _.get(users[e], "profile");
        });

        return regUsers;
    }
);
export const getProfileList = createSelector(
    [getQualificationList],
    qualifications => {
        if (qualifications === false) {
            return [];
        }

        let qualificationDetailsList = [];
        _.forOwn(qualifications, e => {
            qualificationDetailsList.push(e);
        });
        return qualificationDetailsList;
    }
);
export const selectReportTitles = ({ Qualifications_reducer }) => {
    return Qualifications_reducer.reportTitles;
};
